import { useCallback } from 'react';
import { RESULTS_COPY } from './landingContent';
import { LANDING_EVENTS, trackLandingEvent } from './landingAnalytics';
import {
  useCountUp,
  useLandingReveal,
  usePrefersReducedMotion,
  useViewedOnce,
} from './useLandingReveal';

function Stat({ stat, active, reducedMotion }) {
  const counted = useCountUp(stat.value ?? 0, active && !reducedMotion, reducedMotion);

  let value = stat.display;
  if (stat.countUp) {
    const rounded = Math.round(counted).toLocaleString('en-US');
    value = `${rounded}${stat.suffix ?? ''}${stat.trailing ?? ''}`;
  }

  return (
    <li className="lp-result">
      <span className={`lp-result__value${stat.countUp ? ' lp-result__value--mono' : ''}`}>
        {value}
      </span>
      <span className="lp-result__label">{stat.label}</span>
    </li>
  );
}

function ResultsSection() {
  const reducedMotion = usePrefersReducedMotion();
  const [revealRef, revealed] = useLandingReveal();
  const visible = revealed || reducedMotion;

  const handleViewed = useCallback(() => {
    trackLandingEvent(LANDING_EVENTS.resultsViewed);
  }, []);
  const viewedRef = useViewedOnce(0.5, handleViewed);

  return (
    <section className="lp-section lp-results" aria-labelledby="lp-results-heading" ref={viewedRef}>
      <div className="lp-container">
        <div ref={revealRef} className={`lp-reveal${visible ? ' lp-reveal--visible' : ''}`}>
          <p className="lp-label">{RESULTS_COPY.label}</p>
          <h2 id="lp-results-heading" className="lp-heading">
            {RESULTS_COPY.heading}
          </h2>
          <ul className="lp-results__grid">
            {RESULTS_COPY.stats.map((stat) => (
              <Stat key={stat.id} stat={stat} active={visible} reducedMotion={reducedMotion} />
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}

export default ResultsSection;
